// extracted by mini-css-extract-plugin
export default {"section":"Footer_section__WY7UZ","label":"Footer_label__FlY+1"};